import { useChartDataWithTranslations } from 'components/charts/inc-charts.hooks';
import {
  percentageSeries,
  percentageValueFormatter,
} from 'components/charts/inc-charts.utils';
import IncLineChart from 'components/charts/inc-line-chart/inc-line-chart.component';
import { useSearchQueryContext } from 'components/search/search.hooks';
import { dateXAxis } from 'pages/loyalty-performance-report/loyalty-performance-report.utils';
import { useTranslation } from 'react-i18next';

const yAxisValueFormatter = percentageValueFormatter(0);

const FranchiseLoyaltySales = () => {
  const { t } = useTranslation();
  const {
    data,
    queryState: { isFetching },
  } = useSearchQueryContext('franchiseLoyaltySales');
  const series = useChartDataWithTranslations(
    data?.series,
    label => `page.loyaltyPerformanceReport.sales.${label}.label`,
  );

  return (
    <IncLineChart
      series={percentageSeries(series)}
      title={t('page.loyaltyPerformanceReport.sales.title')}
      data-testid="LoyaltySalesLineChart"
      LineChartProps={{
        loading: isFetching,
        xAxis: [dateXAxis(data?.xlabels)],
        yAxis: [{ valueFormatter: yAxisValueFormatter }],
      }}
    />
  );
};

export default FranchiseLoyaltySales;
